export default "<h1>{{title}}</h1>\n<p>\n  manage-categories works!\n</p>\n"